export default __webpack_public_path__ + "marker-500-dd7fba5c8401c352cd602fb405933790.webp";